import React from 'react';
import '../styles/partidaFinalizada.css';
import frasePartidaFinalizada from '../imgs/otros/Letrero partida finalizada recortado.png';
import emojiCelebracion from '../imgs/otros/celebracion (1).png';

export default function PartidaFinalizada() {
    let confetiDiv =[];
    for(let i = 0 ; i < 100; i++){
        confetiDiv.push(<div className='confetti' style={{left: `${Math.random()*100}%`, background: 'hsl('+Math.random()*360+'deg,100%,50%)', animationDuration: (Math.random()*3) + 9 + 's', animationDelay:Math.random()*10 + 's'}}></div>)
    }


    return (
        <div>
            {confetiDiv}
            <div className='partidaFinalizada__div--container'>
                <div className='partidaFinalizada__div--container-letrero'>
                    <img className='partidaFinalizada__img--partida' src={frasePartidaFinalizada} alt="FrasePArtidaFinalizada.png"/>
                    <img className='partidaFinalizada__img--emoji' src={emojiCelebracion} alt="emoji.png"/>
                </div>
            </div>
        </div>
    )
}
